<template>
  <modal :modal-key="'register_info_modal'" @close="$emit('close')" class="modal--welcomeback modal--zero-balance">
    <template slot="header">
      <h1></h1>
      <img class="pinicon" src="static/images/resubscribe_pin.png" alt="">
    </template>
    <template slot="body">
      <p>{{ getTranslations[textKey] }}</p>
    </template>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';

export default {
  name: 'simplify-registration',
  components: {
    Modal,
  },
  props: {
    textKey: {
      type: String,
      default: 'home_modals_simplify_registration_text'
    }
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/flow/SimplifyRegistration.vue